import React, { Component } from "react";
import { inject } from "mobx-react";

import { Add } from "../../api/File";
import {translate} from '../../dictionaries'

@inject(stores => ({
    AuthorizationStore: stores.rootStore.Authorization,
})
)

class AddFile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            status: "init",
            file: null,
            url: null
        }
    }

    uploadFile = async (file) => {
        this.setState({
            status: "loading"
        })

        const formData = new FormData();

        formData.append(`attach`, file);

        const resp = await Add(formData, this.props.AuthorizationStore.token);

        if (resp.status === 200) {
            const data = await resp.json();

            this.setState({
                url: data.id,
                status: "success"
            })


        } else {
            alert(translate('common.error'));

            this.setState({
                status: "init"
            })
        }
    };

    onChange = (e) => {
        const file = e.target.files[0];

        const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

        if (acceptedImageTypes.includes(file['type'])) {
            this.uploadFile(file);
        }
    };

    render() {
        return (
            <div>
                {
                    this.state.status === "loading" &&
                    <p>
                        {translate('common.loading')}
                    </p>
                }
                {
                    (this.state.status === "init" || this.state.status === "success") &&
                    <p>
                        <input value={this.state.file} type="file" onChange={this.onChange} />
                    </p>
                }
                {
                    this.state.status === "success" &&
                    <p>
                        {translate('common.link')}: {this.state.url}
                    </p>
                }
            </div>
        )
    }
}

export default AddFile;